import {
  FDBox,
  FDEmptyState,
  FDSecondaryActionButton,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import MeetingCard from 'Components/UI/MeetingCard/Combined';
import React, { useCallback } from 'react';
import { openModal } from 'Helpers/ModalHelper';
import fr from 'facet-rest';
import moment from 'moment-timezone';
import modalConsts from 'Consts/ModalNames';
import PropTypes from 'prop-types';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';

export const MyMeetingsContent = ({
  householdResource,
  displayScheduleNextMeetingButton,
  meetings,
  previousMeeting,
  refreshMeetings,
}) => {
  const noMeetings = meetings ? meetings.length === 0 && !previousMeeting : true;

  const openScheduleModal = useCallback(async () => {
    const [householdResourceWithTz] = await householdResource.link('self').get({
      params: {
        tz: moment.tz.guess(),
      },
    });
    openModal(modalConsts.clientSchedulerModal, [{
      link: householdResourceWithTz.relationship(fr.relationships.scheduleNewMeeting.name).link('related').url(),
    }]);
  });

  return (
    <>
      <PageHeader
        title="Meetings"
        actions={displayScheduleNextMeetingButton && (
        <FDSecondaryActionButton
          onClick={openScheduleModal}
          test="my-meetings-schedule-new-meeting-button"
          label="Schedule New Meeting"
          icon="dateRange"
        />
        )}
      />
      {noMeetings
        ? (
          <FDStack justifyContent="center" alignItems="center">
            <FDEmptyState title="You haven't had your first meeting" description="" icon="dateRange" />
          </FDStack>
        ) : (
          <>
            {meetings.length > 0 && (
              <FDBox paddingY={4}>
                <FDTitleText value={`Next Meeting${meetings.length > 1 ? 's' : ''}`} size="lg" />
                {!noMeetings && meetings.map((meeting) => (
                  <MeetingCard
                    key={meeting.id()}
                    meeting={meeting}
                    refreshMeetings={refreshMeetings}
                  />))}
              </FDBox>
            )}
            {previousMeeting && (
              <FDBox paddingY={4}>
                <FDTitleText value={'Previous Meeting'} size="lg" />
                <MeetingCard
                  meeting={previousMeeting}
                  pastMeeting
                  muted
                />
              </FDBox>
            )}
          </>
        )}
    </>
  );
};

MyMeetingsContent.propTypes = {
  householdResource: PropTypes.object.isRequired,
  displayScheduleNextMeetingButton: PropTypes.bool.isRequired,
  meetings: PropTypes.array.isRequired,
  previousMeeting: PropTypes.object,
  refreshMeetings: PropTypes.func.isRequired,
};
MyMeetingsContent.defaultProps = {
  previousMeeting: undefined,
};
